// this util serves fixes the issue in safari for the popup blocker to take effect..
// immidiately do the function call via click...
import { v4 as uuid } from 'uuid';

export function preventPopBlocker (f) {
    const btn = document.createElement('button');
    btn.setAttribute('style', 'display: none;');
    btn.onclick = () => {
        f();
        document.body.removeChild(btn);
    }
    document.body.appendChild(btn);
    btn.click();
}

/*
 * use to launch for ios safari.
 * because in safari , openning a link needs to open immediately after click events
 */
export function safariLaunchOauthPopup (qparams) {
    // dispatchViaAnchor('/oauthTalking');
    const btn = document.getElementById('oauth-launcher-button');
    if (btn) {
        btn.href = `/oauthTalking?${qparams}`;
        btn.dispatchEvent(new MouseEvent('click', {
            view: window,
            bubbles: true,
            cancelable: false
        }));
    }
}

export function dispatchViaAnchor (url) {
    const a = document.createElement('A');
    a.href = url;
    a.target = '_top';
    a.dispatchEvent(new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: false
    }));
}

/* TODO: Verify if never used anywhere and remove totally */
export function openTab (url) {
    console.log('openTab():... opening in new tab with a ', url);
    // Create link in memory
    var a = window.document.createElement("a");
    a.target = 'ECAL:OAUTH_SYNCWINDOW';
    a.href = url;
    
    // Dispatch fake click
    var e = window.document.createEvent("MouseEvents");
    e.initMouseEvent("click", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
    a.dispatchEvent(e);
    const syncWindow = window.open('', 'ECAL:OAUTH_SYNCWINDOW');
    console.log('openTab() -> syncWindow(): ', syncWindow);
    return syncWindow;
};

/*
 * Update the Oauth Popup Window url with the correct url and Query params once session id is retrieved.
 */
export function iosChromeUpdateOauthPopupWindow (appStore, qparams) {
    // change the link of the launched popup..
    appStore.iosChromeOauthPop.location.href = `/oauthTalking?${qparams}`;
}

/*
 * iosChromeLaunchOauthPopupNow() open window popup immediately without any url to prevent the popup blocker from blocking the oauth window
 */
export function iosChromeLaunchOauthPopupNow (appStore) {
    const flags = appStore.flags;
    if (flags.ios && flags.chrome) {
        const blob = uuid();
        appStore.iosChromeOauthPop = window.open('', `ECAL:OAUTH_SYNCWINDOW-${blob}`);
        const oauthWindow = window.open('', `ECAL:OAUTH_SYNCWINDOW-${blob}`);
        appStore.pollOauthWindow(oauthWindow);
    }
}